import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { SegmentContext } from './Context';
import { AddSegmentTextMobile } from '../AddSegment';
import { SegmentMobile } from '../SegmentMobile';
import { SearchSegment } from '../../../../models';
import { getSegments, displayFaresInCalendar, isTrainsProductActive } from '../../../../redux/currentSearch/selectors';

// Default = non round trip
export const SegmentManagerDefault = ({ segments, displayFaresInCalendar, isTrainsProduct }) => {
    return (
        <React.Fragment>
            {segments.map((segment, index) => (
                <SegmentContext.Provider key={segment.id} value={{ segment }}>
                    <SegmentMobile
                        key={segment.id}
                        id={segment.id}
                        index={index}
                        totalSegments={segments.length}
                        displayFaresInCalendar={displayFaresInCalendar}
                    />
                </SegmentContext.Provider>
            ))}
            {!isTrainsProduct && <AddSegmentTextMobile />}
        </React.Fragment>
    );
};

SegmentManagerDefault.propTypes = {
    segments: PropTypes.arrayOf(SearchSegment),
    displayFaresInCalendar: PropTypes.bool.isRequired,
};

SegmentManagerDefault.defaultProps = {
    segments: [],
};


const mapStateToProps = createStructuredSelector({
    segments: getSegments,
    displayFaresInCalendar: displayFaresInCalendar,
    isTrainsProduct: isTrainsProductActive,
});

export const ConnectedSegmentManagerDefault = connect(mapStateToProps, null)(SegmentManagerDefault);
